module.exports = __webpack_public_path__ + "static/media/biocertica-logo-with-text-default-horizontal.f126d5c6.svg";